import { motion } from "framer-motion";

export function SectionLabel({ children, className = "", index }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {index && <span className="font-cond text-wutn text-sm tracking-widest">{index}</span>}
      <span className="h-px w-8 bg-wutn" />
      <span className="text-xs uppercase tracking-[0.25em] text-wutn font-bold">{children}</span>
    </div>
  );
}

export function PageHeader({ label, title, subtitle, image, align = "left", testId }) {
  return (
    <section data-testid={testId} className="relative pt-40 pb-16 md:pb-24 overflow-hidden border-b border-white/10">
      {image && (
        <div className="absolute inset-0 z-0">
          <img src={image} alt="" className="w-full h-full object-cover opacity-25" />
          <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-black/40" />
        </div>
      )}
      <div className="relative z-10 mx-auto max-w-[1400px] px-5 sm:px-8">
        <SectionLabel>{label}</SectionLabel>
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="mt-5 font-display uppercase text-5xl sm:text-7xl lg:text-8xl leading-[0.88] tracking-tight max-w-4xl"
        >
          {title}
        </motion.h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.25, duration: 0.8 }}
            className="mt-6 text-zinc-400 text-lg max-w-2xl"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
}
